import React, { memo } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { InputBox, Layout } from '../../../../../../../components';
import { RegisterLimitFormValues, RegisterLimitSchemaProps } from '../../lib/schema';
import ExpirationDateTag from '../ExpirationDateTag/ExpirationDateTag';
import styles from './RegisterLimitPageHeader.module.scss';

type RegisterLimitPageHeaderProps = {
  form: UseFormReturn<RegisterLimitFormValues, unknown, RegisterLimitSchemaProps>;
  expirationDate?: string;
};

const RegisterLimitPageHeader = ({ form, expirationDate }: RegisterLimitPageHeaderProps) => {
  return (
    <Layout.Section padded className={styles.card}>
      <div className={styles['header-container']}>
        <Layout.Title className={styles.title}>Cadastro de limite</Layout.Title>
        {expirationDate && <ExpirationDateTag expirationDate={expirationDate} />}
      </div>
      <Controller
        name="name"
        control={form.control}
        render={({ field, fieldState: { error } }) => (
          <InputBox className={styles['input-box']}>
            <InputBox.Label htmlFor="name">Nome do limite</InputBox.Label>
            <InputBox.Input {...field} />
            <InputBox.Error message={error?.message} />
          </InputBox>
        )}
      />
    </Layout.Section>
  );
};

export default memo(RegisterLimitPageHeader);
